import React, { useEffect, useState } from 'react';

const CustomCursor: React.FC = () => {
  const [position, setPosition] = useState({ x: -100, y: -100 });
  const [isPointer, setIsPointer] = useState(false);
  const [isHidden, setIsHidden] = useState(true);

  useEffect(() => {
    const onMouseMove = (e: MouseEvent) => {
      setPosition({ x: e.clientX, y: e.clientY });
      setIsHidden(false);
    };

    const onMouseOver = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const isClickable = 
        target.tagName === 'BUTTON' || 
        target.tagName === 'A' || 
        target.closest('button') || 
        target.closest('a') ||
        window.getComputedStyle(target).cursor === 'pointer';
      
      setIsPointer(!!isClickable);
    };

    const onMouseLeave = () => setIsHidden(true);
    const onMouseEnter = () => setIsHidden(false);

    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseover', onMouseOver);
    document.addEventListener('mouseleave', onMouseLeave);
    document.addEventListener('mouseenter', onMouseEnter);

    return () => {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseover', onMouseOver);
      document.removeEventListener('mouseleave', onMouseLeave);
      document.removeEventListener('mouseenter', onMouseEnter);
    };
  }, []);

  if (isHidden) return null;

  return (
    <>
      {/* Outer Ring */}
      <div
        className="fixed top-0 left-0 pointer-events-none z-[9999] rounded-full border border-pink-300/50 transition-transform duration-300 ease-out"
        style={{
          width: '32px',
          height: '32px',
          transform: `translate(${position.x - 16}px, ${position.y - 16}px) scale(${isPointer ? 1.8 : 1})`,
          backgroundColor: isPointer ? 'rgba(244, 114, 182, 0.1)' : 'transparent',
        }}
      />
      {/* Inner Dot */}
      <div
        className="fixed top-0 left-0 pointer-events-none z-[10000] w-1.5 h-1.5 bg-pink-400 rounded-full transition-transform duration-75 ease-out"
        style={{
          transform: `translate(${position.x - 3}px, ${position.y - 3}px)`,
          opacity: isPointer ? 0.5 : 1,
        }}
      />
    </>
  );
};

export default CustomCursor;